import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../Assets/Css/Upload.css";
import CameraComponent from "../../Components/CameraComponent/CameraComponent";
import Logo from "../../Assets/Images/DigiDoc Head.png";
import camIcon from "../../Assets/Images/CameraIcon.png";
import config from "../../Config";

const Upload = () => {
  const navigate = useNavigate();
  const [showCamera, setShowCamera] = useState(false);
  const [currentMedicine, setCurrentMedicine] = useState(null);
  const [capturedImages, setCapturedImages] = useState({});
  const [prescription, setPrescription] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // Fetch prescription data from the API
  useEffect(() => {
    const patientId = sessionStorage.getItem("patientid");
    const token = sessionStorage.getItem("authToken");
    

    if (!patientId || !token) {
      setErrorMessage("Authentication failed. Please log in again.");
      return;
    }

    const fetchPrescription = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}/patient/fetch/medicine/${patientId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200 && response.data?.data) {
          console.log("Fetched Prescription:", response.data.data);
          setPrescription(response.data.data);

            // Store prescription_id and doctor_id in sessionStorage
        sessionStorage.setItem("prescription_id", response.data.data.prescription_id);
        sessionStorage.setItem("doctor_id", response.data.data.doctor_id);
        
        } else {
          setErrorMessage("Failed to fetch prescription data.");
        }
      } catch (error) {
        setErrorMessage("Error fetching prescription data.");
        console.error(error);
      }
    };

    fetchPrescription();
  }, []);

  const handleCameraClick = (medicine) => {
    setShowCamera(true);
    setCurrentMedicine(medicine);
  };

  const handleImageCapture = (image) => {
    setCapturedImages((prevImages) => ({
      ...prevImages,
      [currentMedicine]: image,
    }));
    setShowCamera(false);
    setCurrentMedicine(null);
  };

  const handleNextClick = () => {
    const allImagesUploaded = Object.values(capturedImages).every(Boolean);
    if (allImagesUploaded) {
      navigate("/confirm-upload", {
        state: { 
          images: Object.values(capturedImages),
          doctorName: prescription?.doctor || "Not Assigned", // Pass doctor name
          prescribedMedicines: prescription?.medicine || [] // Pass prescribed medicines
        },
      });
    } else {
      setErrorMessage("Please upload all medicine images before proceeding.");
    }
  };
  

  return (
    <div className="app-container">
      {showCamera ? (
        <CameraComponent
          onCapture={handleImageCapture}
          onClose={() => setShowCamera(false)}
        />
      ) : (
        <div className="upload-container">
          <div className="uheader">
            <img src={Logo} alt="DigiDoc Logo" className="ulogo" />
          </div>

          <h3 className="doctor-name">
            Dr. {prescription?.doctor || "Not Assigned"}
          </h3>
          <p className="prescribed-medicines-heading">Prescribed Medicines</p>

          {prescription?.medicine?.length > 0 ? (
            <ul className="medicine-list">
              {prescription.medicine.map((med, index) => (
                <li key={index}>
                  <strong>{med.medicine_name}</strong> - {med.dosage}
                </li>
              ))}
            </ul>
          ) : (
            <p>No medicines prescribed.</p>
          )}

          {prescription?.medicine?.map((med, index) => (
            <div key={med.id} className="medicine-upload">
              <label style={{ display: "inline-block" }}>
                Medicine {index + 1} <span style={{ color: "red" }}>*</span>
              </label>
              <div className="upload-input">
                {capturedImages[med.medicine_name] ? (
                  <img
                    src={capturedImages[med.medicine_name]}
                    alt={`Captured for Medicine ${index + 1}`}
                    style={{ width: "50px", height: "50px" }}
                  />
                ) : (
                  <span>Upload Medicine Picture</span>
                )}
                <button
                  className="camera-button"
                  onClick={() => handleCameraClick(med.medicine_name)}
                >
                  <img src={camIcon} alt="Camera" className="icon-image" />
                </button>
              </div>
            </div>
          ))}

          {errorMessage && (
            <p
              className="error-message"
              style={{
                color: "red",
                fontFamily: "Avenir LT STD",
                fontSize: "12px",
              }}
            >
              {errorMessage}
            </p>
          )}

          <button className="next-button" onClick={handleNextClick}>
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Upload;
